var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useLocation } from "react-router-dom";
export function useQuery() {
    return new URLSearchParams(useLocation().search);
}
export function getQueryParameterName(paramName) {
    var query = useQuery();
    return query.get(paramName);
}
export function changesQueryParameter(cb, queryList) {
    var queryObj = {};
    queryList.forEach(function (query) {
        queryObj = __assign(__assign({}, queryObj), query);
    });
    return cb(queryObj);
}
